import type { ILearningCampaignParticipantSummaryInfo } from "@kiraah-shared/common";

export function showMobileLearningCampaignActivationCountdown(
  campaign: ILearningCampaignParticipantSummaryInfo | null | undefined
): boolean {
  if (!campaign || campaign.CompletedAtString) {
    return false;
  }

  return campaign.CanRespond === false && !!campaign.ActivationCountdownLabelKey;
}

export function canOpenMobileLearningCampaign(
  campaign: ILearningCampaignParticipantSummaryInfo | null | undefined
): boolean {
  if (!campaign?.Uid) {
    return false;
  }

  if (campaign.CompletedAtString) {
    return true;
  }

  return campaign.CanRespond !== false;
}
